const BasicInfoBox = ({ id, userData, onDelete, onInputChange, isDeletable, errorMessage }) => {
  return (
    <div className="basic_info_box">
      <div className="row">
        <div className="col-md-6 col-lg-4">
          <div className="basic_info_inp_head">
            <label>Name</label>
          </div>
          <div className="inp_holder">
            <input
              type="text"
              placeholder="Name"
              autoComplete="abcd"
              value={userData.user_name}
              onChange={(e) => onInputChange(id, "user_name", e.target.value)}
              required
            />
          </div>
        </div>
        
        <div className="col-md-6 col-lg-4">
          <div className="basic_info_inp_head">
            <label>Email</label>
          </div>
          <div className="inp_holder">
            <input
              type="email"
              placeholder="Email"
              autoComplete="abcd"
              value={userData.user_email}
              onChange={(e) => onInputChange(id, "user_email", e.target.value)}
              required
            />
            {/* Show error message if exists */}
            {errorMessage && <div className="error-message text-danger">{errorMessage}</div>}
          </div>
        </div>

        <div className="col-md-6 col-lg-4">
          <div className="basic_info_inp_head d-flex justify-content-between">
            <label>Company (optional)</label>
            {isDeletable && (
              <a className="del_com" href="#!" onClick={() => onDelete(id)}>
                <i className="fa-solid fa-trash-can"></i>
              </a>
            )}
          </div>
          <div className="inp_holder">
            <input
              type="text"
              placeholder="Company"
              autoComplete="abcd"
              value={userData.user_company}
              onChange={(e) => onInputChange(id, "user_company", e.target.value)}
            />
          </div>
        </div>

        <div className="col-md-6 col-lg-4">
          <div className="basic_info_inp_head">
            <label>Password</label>
          </div>
          <div className="inp_holder">
            <input
              type="password"
              autoComplete="abcd"
              placeholder="Password"
              value={userData.user_password}
              onChange={(e) => onInputChange(id, "user_password", e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfoBox;
